import { initializeSprinkles } from '@react/sprinkles';
import { initBugsnag } from './config/bugsnag';

initBugsnag();

const getComponentContext = () => {
    const context = require.context('./', true, /\.js$/);

    const keys = context.keys();

    const findEventSessions = new RegExp(/^\.\/EventSessionsApp\.js$/);
    const found = keys.find(path => path.match(findEventSessions));

    if (found) {
        context(found);
    }

    return context;
};

initializeSprinkles(getComponentContext);